import React from "react";
import { Container, Typography, Paper, Box, Stack } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Reviews.css";
import { useSelector } from "react-redux";
import { t } from "../../utils/i18n";
const Reviews = () => {
  const lang = useSelector((state) => state.i18n.lang);
  const testimonialsState = useSelector(
    (state) => state.productData.testimonials
  );
  const reviews = Array.isArray(testimonialsState.data)
    ? testimonialsState.data.map((t) => ({
        name: lang === "ar" ? t.ar_name : t.name,
        course: lang === "ar" ? t.ar_position : t.position,
        review: lang === "ar" ? t.ar_message : t.message,
        rating: t.rating || 5,
        photo: t.photo || t.avatar || t.image || "",
      }))
    : [];

  if (!Array.isArray(reviews) || reviews.length === 0) {
    return null;
  }


  return (
    <Box id="reviews" className="reviews-section" mb={11}>
      <Box
        className="main-section"
        sx={{
          px: "30px !important",
          width: "90%",
          mx: "auto",
          backgroundColor: (theme) => theme.palette.background.reviews,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={500}
          mb={-1}
          className="reviews-title"
        >
          {t(lang, "reviews.reviews")}
        </Typography>
        <Typography variant="h2" sx={{ mt: 2}}>
          {t(lang, "reviews.change_moments")}
        </Typography>

        <Box
          sx={{
            mt: 5,
            "& .swiper-pagination-bullet": {
              backgroundColor: "transparent",
              border: "1px solid #AAA",
              width: 14,
              height: 14,
              opacity: 0.5,
            },
            "& .swiper-pagination-bullet-active": {
              backgroundColor: "#000",
              opacity: 1,
            },
          }}
        >
          <Swiper
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              600: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            modules={[Navigation, Pagination, Autoplay]}
            navigation={false}
            pagination={{
              clickable: true,
              dynamicBullets: true, // Optional: makes pagination dots more compact
            }}
            loop={true}
            autoplay={{ delay: 6000 }}
            className="mySwiper"
            style={{ paddingBottom: 60 }}
          >
            {reviews.map((review, index) => (
              <SwiperSlide key={index}>
                <Paper
                  elevation={3}
                  className="review-card"
                  sx={{
                    bgcolor: (theme) => theme.palette.background.reviewCard,
                    borderRadius: 6,
                    pt: 1,
                  }}
                >
                  <Box
                    sx={{
                      px: 3,
                      py: 1,
                      pb: 1,
                      bgcolor: "",
                      height: 200,
                      borderRadius: 2,
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems={"center"}
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        pb: 1,
                        borderBottom: "2px solid #AAA",
                        mb: 1,
                      }}
                    >
                      <Box
                        sx={{
                          mr: lang === "ar" ? 0 : 2,
                          ml: lang === "ar" ? 2 : 0,
                        }}
                      >
                        <img
                          src={`https://dolftech.com/storage/testimonial/${review.photo}`}
                          alt={review.name}
                          loading="lazy"
                          width={50}
                          height={50}
                          style={{ borderRadius: "50%" }}
                        />
                      </Box>
                      <Box>
                        <Typography variant="h3" fontWeight={700}>
                          {review.name}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight={400}
                          my={-0.3}
                          color="#949191ff"
                        >
                          {review.course}
                        </Typography>
                      </Box>
                    </Stack>
                    <Box>
                      {/* Star Rating using MUI Rating component */}
                      <Box sx={{ mb: 1 }}>
                        {[...Array(5)].map((_, i) => (
                          <span
                            key={i}
                            style={{
                              color: i < review.rating ? "#f5c518" : "#ddd",
                              fontSize: "1.2rem",
                              marginRight: "2px",
                            }}
                          >
                            ★
                          </span>
                        ))}
                      </Box>
                      <Typography
                        variant="body1"
                        fontWeight={400}
                        dangerouslySetInnerHTML={{ __html: review.review }}
                      />
                    </Box>
                  </Box>
                </Paper>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Box>
    </Box>
  );
};

export default Reviews;
